import axios from 'axios';
import { useMutation, useQuery } from 'react-query';

import type { User, UserResponse } from 'src/types/user';

export function useUser(id: User['id']) {
  return useQuery<UserResponse, unknown, User>(
    ['users', id],
    () => axios.get(`/api/users/${id}`),
    {
      select: (data) => data.data,
    }
  );
}

type PartialData = { id: User['id'] } & Pick<
  User,
  'firstName' | 'lastName' | 'avatarUrl'
>;
export function useUpdateUserMutation(data: PartialData) {
  const { id, ...values } = data;
  return useMutation(() => axios.patch(`/api/users/${id}`, values));
}
